var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5547,
    cy: 28.1445,
    r: 26.5,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7094 21.5089V25.3304C37.5874 25.236 35.5346 24.5258 33.8043 23.2814L33.0124 22.7119V23.6873V33.47C33.0124 38.0799 29.2619 41.8298 24.6529 41.8302C22.4362 41.827 20.3113 40.9452 18.7437 39.3779C17.1763 37.8107 16.2941 35.6861 16.2905 33.4696C16.2907 28.8608 20.04 25.1104 24.6496 25.1097C24.8817 25.1108 25.1136 25.1216 25.3448 25.142V28.979C25.116 28.9426 24.8844 28.9238 24.6521 28.9232L24.6511 28.9232C23.7595 28.9226 22.8875 29.1843 22.1436 29.6756C21.3997 30.1669 20.8167 30.8662 20.4673 31.6864C20.1179 32.5066 20.0174 33.4114 20.1784 34.2883C20.3394 35.1652 20.7548 35.9753 21.3728 36.6179C21.9908 37.2604 22.7842 37.707 23.6541 37.902C24.524 38.097 25.4321 38.0318 26.2653 37.7146C27.0984 37.3973 27.8199 36.842 28.3398 36.1178C28.8597 35.3935 29.1551 34.5324 29.1892 33.6415L29.1895 33.632L29.1895 33.6226L29.1968 14.8302H33.0302C33.0495 15.1029 33.0843 15.3744 33.1344 15.6434L33.1345 15.6437C33.3138 16.6027 33.6859 17.5153 34.2282 18.3263C34.7704 19.137 35.4715 19.8293 36.289 20.3612C37.3147 21.0311 38.4927 21.425 39.7094 21.5089Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.fd8bcd76e30394eb6419c929e27f8718.svg";
export { ForwardRef as ReactComponent };